import {forwardRef, useEffect, useState} from 'react'
import utils from '@eitje/utils'
import {useCountdown} from '@eitje/hooks'
import _ from 'lodash'
import {Icon} from '../icon'
import {Text, Title} from '../text'
import {Layout} from '../layout'
import {makeCnVariants} from '~/helpers'
import './styles/notification.less'

const HandleCount = ({setCount, duration = 5, handleClose}) => {
	const count = useCountdown(duration)

	useEffect(() => {
		if (count <= 0) handleClose()
		setCount(count)
	}, [count])

	return null
}

export const Notification = forwardRef((props, ref) => {
	let {
		title,
		content,
		icon,
		baseColor,
		colorSet = baseColor ? 'color-bordered-outline' : true,
		handleClose = _.noop,
		duration,
		small,
		onClick,
	} = props

	const [count, setCount] = useState(duration)
	const countValue = Math.max(0, Math.floor(count))

	// TODO: layout. BaseColor and colorSet is used 3 times here in 4 nested layouts. We can improve on this
	const _colorSet = {
		baseColor,
		colorSet,
	}

	const classNames = makeCnVariants('notification', small ? 'small' : 'large')
	const condOpts = {}
	if (onClick) {
		condOpts.onClick = onClick
	}

	// When the notif has a count prop and the count has reached 0, we ensure nothing is returned.
	// This is to ensure that we don't see a glitch of the disappearning notif
	if (props.duration > 0 && count <= 0) return null

	// Convert children to text, but also allow components and elements to be passed,
	// such as <br/> and <ModalLink/>. Those should not be converted to strings by Text's
	// inner logic, so simply pass them as JSX.
	content =
		content &&
		utils.alwaysArray(content).map(child => {
			return _.isString(child) ? <Text bold>{content}</Text> : child
		})

	return (
		<Layout onClick={onClick} ref={ref} className={classNames} padding={12} width={!small && 500} direction="vertical" {..._colorSet}>
			{(props.duration > 0 || small) && <HandleCount setCount={setCount} duration={duration} handleClose={handleClose} />}
			<Layout horizontal="spaceBetween" {..._colorSet}>
				<Layout gap={8} {..._colorSet}>
					<Icon size="14px" name={icon} />
					<Title>{title}</Title>
				</Layout>

				{!small && (
					<Layout className="notification-right-content" gap={12} vertical="center" {..._colorSet}>
						{props.duration > 0 && <Text>{countValue}</Text>}
						<Icon size="10px" onClick={handleClose} name="cross" />
					</Layout>
				)}
			</Layout>
			{content && (
				<Layout direction="vertical" className="notification-content" gap={8} {..._colorSet}>
					{content}
				</Layout>
			)}
		</Layout>
	)
})
